import * as React from "react";
import { useState, useEffect } from "react";
import { Button } from "./Button";
import MuiButton from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { ApiCall } from "../../utility/ApiCalls";
import Api_Call from "../../ApiCall";
import { Grid } from "@mui/material";
import { PropaneSharp } from "@mui/icons-material";
import UserContext from "../Common/UserContext";

export default function DialogBox(props) {
  const [open, setOpen] = React.useState(false);
  const [cptDescription, setCPTDescription] = useState();
  const [cptCode, setCPTCode] = useState();
  const [cptunits, setCPTUnits] = useState(1);
  const [cptCodeID, setCPTCodeID] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dxDescription, setDXDescription] = useState();
  const [dxCode, setDXCode] = useState();
  const [dxCodeID, setDXCodeID] = useState();

  const [providerName, setProviderName] = useState();
  const [providerNPI, setProviderNPI] = useState();
  const [providerTax, setProviderTax] = useState();
  const [providerAddress, setProviderAddress] = useState();
  const [providerCity, setProviderCity] = useState();
  const [providerState, setProviderState] = useState();
  const [providerZip, setProviderZip] = useState();
  const [providerPhone, setProviderPhone] = useState();
  const [providerFax, setProviderFax] = useState();
  const [providerType, setProviderType] = useState();
  const [providerID, setProviderID] = useState();
  const [uiProviderId, setUIProviderId] = useState();
  const [newEntry, setNewEntry] = useState();
  const { userId } = React.useContext(UserContext);

  const handleClickOpen = () => {
    setOpen(true);
  };
  console.log(newEntry);
  const handleClose = () => {
    setOpen(false);
  };
  console.log(
    props.ButtonID,
    props.proc,
    props.rowID,
    props.newEntry,
    cptCodeID,
    props.newEntry && cptCodeID == undefined ? props.newEntry : cptCodeID
  );
  ///////AJAX CALL to SERVICES////////////////////
  async function getDescriptionfromAPI(cpt) {
    setIsLoading(true);
    // const retActive = await ApiCall(
    //   {
    //     PXC_Code: cpt,
    //   },
    //   "vcare-ui",
    //   "vcare_validateprocedurecode"
    // );
    //   "cptCode": cpt,
    // }, 'vcare-ui', 'agent_gettaskdetails/getcptdetails');
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/PROCEDURECODE-VALIDATION", {
      PXC_Code: cpt,
    });

    const response = data.body;
    if (response == "Procedure Code validated successfully.") {
      toast.success(response, { autoClose: true });
    } else {
      toast.error(response, { autoClose: true });
      setOpen(true);
    }
    // setCPTDescription(response.CPTDesc);
    setCPTCode(cpt);
    setIsLoading(false);
  }

  async function updatedCptValueAPI(cpt, units, cptCodeID) {
    setIsLoading(true);
    console.log("-----------");
    console.log(newEntry);
    const CPTID = props.newEntry.filter(
      (item) => item.row == props.rowID && item.type == "CPT"
    );
    // console.log(CPTID[0]["ID"]);
    const api = new Api_Call();
    const data = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "CPT",
      newValue: {
        CPTCode: cpt,
        Units: units,
        CPTCode_ID:
          props.newEntry && cptCodeID == undefined ? CPTID[0]["ID"] : cptCodeID,
      },
      op_type: "update",
    });
    // const retActive = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "CPT",
    //     newValue: {
    //       CPTCode: cpt,
    //       Units: units,
    //       CPTCode_ID: cptCodeID,
    //     },
    //     op_type: "update",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    toast.success("CPT Update Successfully");
  }

  async function getDXDescriptionfromAPI(dx) {
    setIsLoading(true);
    // const retActive = await ApiCall(
    //   {
    //     DXC_Code: dx,
    //   },
    //   "vcare-ui",
    //   "vcare_validatediagnosiscode"
    // );
    const api = new Api_Call();
    const data = await api.postData("VALIDATIONS/DIAGNOSISCODE-VALIDATION", {
      DXC_Code: dx,
    });
    //   "dxCode": dx,
    // }, 'vcare-ui', 'agent_gettaskdetails/getdxdetails');

    const response = data.body;
    if (response == "Diagnosis Code validated successfully.") {
      toast.success(response, { autoClose: true });
    } else {
      toast.error(response, { autoClose: true });
      setOpen(true);
    }
    // setDXDescription(response.DxDesc);
    setDXCode(dx);
    setIsLoading(false);
  }

  async function updatedDxValueAPI(dx, dxCodeID) {
    const DXID = props.newEntry.filter(
      (item) => item.row == props.rowID && item.type == "DX"
    );
    // console.log(DXID[0]["ID"]);
    const api = new Api_Call();
    const data = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "DX",
      newValue: {
        DXCode: dx,
        DXCode_ID:
          props.newEntry && dxCodeID == undefined ? DXID[0]["ID"] : dxCodeID,
      },
      op_type: "update",
    });
    // const retActive = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "DX",
    //     newValue: { DXCode: dx, DXCode_ID: dxCodeID },
    //     op_type: "update",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    toast.success("Diagnosis Update Successfully");
  }
  /////////////////////END/////////////////////////////

  ///////CRUD OPERATIONS////////////////////////////
  async function AddCPT() {
    setOpen(false);
    getDescriptionfromAPI(cptCode);

    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "CPT",
      newValue: {
        CPTCode: cptCode,
        Units: cptunits,
      },
      op_type: "add",
    });

    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "CPT",
    //     newValue: {
    //       CPTCode: cptCode,
    //       Units: cptunits,
    //     },
    //     op_type: "add",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newArray = [...props.processData];
      newArray.splice(newArray.length + 1, 0, {
        CPTCode_CR: cptCode,
        DescriptionText_CR: cptDescription,
        Unit_NR: cptunits,
      });
      console.log(res.body.ID);
      props.setNewEntry((prevValue) => [
        ...prevValue,
        {
          type: "CPT",
          ID: res.body.ID,
          row: props.rowLength,
        },
      ]);
      props.setterMethod(newArray);
      toast.success(res.body.msg);
    }
  }

  async function AddDX() {
    setOpen(false);
    getDXDescriptionfromAPI(dxCode);
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "DX",
      newValue: { DXCode: dxCode },
      op_type: "add",
    });
    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "DX",
    //     newValue: { DXCode: dxCode },
    //     op_type: "add",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newArray = [...props.processData];
      newArray.splice(newArray.length + 1, 0, {
        DXCode_CR: dxCode,
        DescriptionText_CR: dxDescription,
      });
      console.log(res.body.ID);
      props.setNewEntry((prevValue) => [
        ...prevValue,
        {
          type: "DX",
          ID: res.body.ID,
          row: props.rowLength,
        },
      ]);
      props.setterMethod(newArray);
      toast.success(res.body.msg);
    }
  }

  async function AddProvider() {
    setOpen(false);
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "Provider",
      newValue: {
        Name: providerName,
        NPI: providerNPI,
        Address: providerAddress,
        PhoneNumber: providerPhone,
        FaxNo: providerFax,
        ProviderType: providerType,
      },
      op_type: "add",
    });
    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "Provider",
    //     newValue: {
    //       Name: providerName,
    //       NPI: providerNPI,
    //       Address: providerAddress,
    //       PhoneNumber: providerPhone,
    //       FaxNo: providerFax,
    //       ProviderType: providerType,
    //     },
    //     op_type: "add",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newArray = [...props.processData];
      newArray.splice(newArray.length + 1, 0, {
        ProviderName: providerName,
        NPIID_CR: providerNPI,
        TaxID_CR: providerTax,
        Address_CR: providerAddress,
        City_CR: providerCity,
        State_CR: providerState,
        Zip_CR: providerZip,
        PhoneNumber_CR: providerPhone,
        FaxNo_CR: providerFax,
        ProviderType_CR: providerType,
      });
      props.setNewEntry((prevValue) => [
        ...prevValue,
        {
          type: "Provider",
          ID: res.body.ID,
          row: props.rowLength,
        },
      ]);
      props.setterMethod(newArray);
      toast.success(res.body.msg);
    }
  }

  function UpdateCPT() {
    cptUpdateCode();
    const newState = [...props.processData];
    newState[props.rowID] = {
      CPTCode_CR: cptCode,
      DescriptionText_CR: cptDescription,
      Unit_NR: cptunits,
      CPTCode_ID: cptCodeID,
    };
    props.setterMethod(newState);
    setOpen(false);
  }

  function UpdateDX() {
    // console.log('props in update DX code ', props);
    dxUpdateCode();
    const newState = [...props.processData];
    newState[props.rowID] = {
      DXCode_CR: dxCode,
      DescriptionText_CR: dxDescription,
      DXCode_ID: dxCodeID,
    };
    props.setterMethod(newState);
    // console.log('new state ', newState);
    setOpen(false);
  }

  async function updatedProviderValueAPI() {
    const ProviderID = props.newEntry.filter(
      (item) => item.row == props.rowID && item.type == "Provider"
    );
    // console.log(ProviderID[0]["ID"]);
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "Provider",
      newValue: {
        UIProvider_ID:
          props.newEntry && uiProviderId == undefined
            ? ProviderID[0]["ID"]
            : `${uiProviderId}`,
        Name: providerName,
        NPI: providerNPI,
        Address: providerAddress,
        PhoneNumber: providerPhone,
        FaxNo: providerFax,
        ProviderType: providerType,
      },
      op_type: "update",
    });
    // const retActive = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "Provider",
    //     newValue: {
    //       Name: providerName,
    //       NPI: providerNPI,
    //       Address: providerAddress,
    //       PhoneNumber: providerPhone,
    //       FaxNo: providerFax,
    //       ProviderType: providerType,
    //     },
    //     op_type: "update",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    toast.success("Provider Update Successfully");
  }

  function UpdateProvider() {
    const newState = [...props.processData];
    newState[props.rowID] = {
      ProviderName: providerName,
      NPIID_CR: providerNPI,
      TaxID_CR: providerTax,
      Address_CR: providerAddress,
      City_CR: providerCity,
      State_CR: providerState,
      Zip_CR: providerZip,
      PhoneNumber_CR: providerPhone,
      FaxNo_CR: providerFax,
      ProviderType_CR: providerType,
    };
    props.setterMethod(newState);
    updatedProviderValueAPI();
    setOpen(false);
  }

  async function removeDxRow() {
    setOpen(false);
    let processDataVal = props.processData[props.rowID];
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "DX",
      newValue: { DXCode: processDataVal.DXCode_CR },
      op_type: "delete",
    });
    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "DX",
    //     newValue: { DXCode: processDataVal.DXCode_CR },
    //     op_type: "delete",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newState = [...props.processData];
      newState.splice(props.rowID, 1);
      props.setterMethod(newState);
      toast.success(res.body.msg);
    }
  }

  async function removeCPTRow() {
    setOpen(false);
    let processDataVal = props.processData[props.rowID];
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "CPT",
      newValue: {
        CPTCode: processDataVal.CPTCode_CR,
        Units: processDataVal.Unit_NR,
      },
      op_type: "delete",
    });
    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "CPT",
    //     newValue: {
    //       CPTCode: processDataVal.CPTCode_CR,
    //       Units: processDataVal.Unit_NR,
    //     },
    //     op_type: "delete",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newState = [...props.processData];
      newState.splice(props.rowID, 1);
      props.setterMethod(newState);

      toast.success(res.body.msg);
    }
  }

  async function removeProviderRow() {
    setOpen(false);
    let processDataVal = props.processData[props.rowID];
    const api = new Api_Call();
    const res = await api.putData("FAX/UPDATE-FIELD", {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "Provider",
      newValue: {
        Name: processDataVal.ProviderName,
        NPI: processDataVal.NPIID_CR,
        Address: processDataVal.Address_CR,
        PhoneNumber: processDataVal.PhoneNumber_CR,
        FaxNo: processDataVal.FaxNo_CR,
        ProviderType: processDataVal.ProviderType_CR,
      },
      op_type: "delete",
    });
    // const res = await ApiCall(
    //   {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "Provider",
    //     newValue: {
    //       Name: processDataVal.ProviderName,
    //       NPI: processDataVal.NPIID_CR,
    //       Address: processDataVal.Address_CR,
    //       PhoneNumber: processDataVal.PhoneNumber_CR,
    //       FaxNo: processDataVal.FaxNo_CR,
    //       ProviderType: processDataVal.ProviderType_CR,
    //     },
    //     op_type: "delete",
    //   },
    //   "vcare-ui",
    //   "vcare_updatefield"
    // );
    if (res) {
      const newState = [...props.processData];
      newState.splice(props.rowID, 1);
      props.setterMethod(newState);
      toast.success(res.body.msg);
    }
  }

  function removeDX() {
    const newState = [...props.processData];
    newState.splice(props.rowID, 1);

    props.setterMethod(newState);
    setOpen(false);
  }
  /////////////////////END/////////////////////////////

  useEffect(() => {
    if (props.ButtonID == "BtnCPT" && props.proc == "update") {
      setCPTCode(props.processData[props.rowID].CPTCode_CR);
      setCPTCodeID(props.processData[props.rowID].UICPTCode_ID);
    } else if (props.ButtonID == "BtnDX" && props.proc == "update") {
      setDXCode(props.processData[props.rowID].DXCode_CR);
      setDXCodeID(props.processData[props.rowID].UIDXCode_ID);
    } else if (props.ButtonID == "BtnProvider" && props.proc == "update") {
      if (props.processData.length > 0) {
        setUIProviderId(props.processData[props.rowID].UIProvider_ID);
        setProviderName(props.processData[props.rowID].ProviderName);
        setProviderNPI(props.processData[props.rowID].NPIID_CR);
        setProviderTax(props.processData[props.rowID].TaxID_CR);
        setProviderAddress(props.processData[props.rowID].Address_CR);
        setProviderCity(props.processData[props.rowID].City_CR);
        setProviderState(props.processData[props.rowID].State_CR);
        setProviderZip(props.processData[props.rowID].Zip_CR);
        setProviderPhone(props.processData[props.rowID].PhoneNumber_CR);
        setProviderFax(props.processData[props.rowID].FaxNo_CR);
        setProviderType(props.processData[props.rowID].ProviderType_CR);
      }
    }
  }, []);

  ///////////EFFECT for Getting Description///////////////
  const dxUpdateCode = () => {
    const delayDebounceFn = setTimeout(() => {
      // console.log(dxCode, dxCodeID);
      getDXDescriptionfromAPI(dxCode);
      updatedDxValueAPI(dxCode, dxCodeID);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  };

  const cptUpdateCode = () => {
    const delayDebounceFn = setTimeout(() => {
      console.log(cptCode, cptCodeID);
      getDescriptionfromAPI(cptCode);
      updatedCptValueAPI(cptCode, cptunits, cptCodeID);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  };

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     getDescriptionfromAPI(cptCode);
  //   }, 1000);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [cptCode]);

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     getDXDescriptionfromAPI(dxCode);
  //   }, 1000);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [dxCode]);
  /////////////////////END/////////////////////////////

  if (props.ButtonID == "BtnCPT") {
    if (props.proc == "add") {
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            {props.taskStatus != 3 &&
            props.taskStatus != 7 &&
            // props.taskStatus != 5 &&
            // props.taskStatus != 6 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 ? (
              <MuiButton
                variant="outlined"
                size="small"
                onClick={handleClickOpen}
                startIcon={<PlaylistAddIcon fontSize="inherit" />}
                style={{
                  borderColor: "#FB4E0B",
                  borderWidth: 1,
                  borderStyle: "solid",
                  color: "#000000",
                  backgroundColor: "#fff",
                  padding: 5,
                }}
              >
                {props.AddButtonText}
              </MuiButton>
            ) : (
              ""
            )}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-cpt-dialog"
            >
              <DialogTitle>Add CPT Code</DialogTitle>
              <DialogContent>
                <DialogContentText> CPT Code: </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="cpt"
                  fullWidth
                  variant="standard"
                  value={cptCode}
                  onChange={(e) => setCPTCode(e.target.value)}
                />
                {/* <DialogContentText> Description: </DialogContentText>
                <TextareaAutosize minRows={4} aria-label="maximum height" style={{ width: 200 }} value={cptDescription} /> */}
                <DialogContentText> Units: </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="units"
                  fullWidth
                  variant="standard"
                  value={cptunits}
                  onChange={(e) => setCPTUnits(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={AddCPT}>Add</Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "update") {
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            <BorderColorOutlinedIcon
              sx={{ color: "#2F3744", cursor: "pointer" }}
              onClick={handleClickOpen}
            />
            {/* <Button
              buttonStyle={props.buttonStyle}
              buttonSize="btn--small"
              onClick={handleClickOpen}
            >
              <i className="fas fa-pen"></i>
            </Button> */}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-cpt-dialog"
            >
              <DialogTitle>Update CPT Code</DialogTitle>
              <DialogContent>
                <DialogContentText> CPT Code: </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="cpt"
                  fullWidth
                  variant="standard"
                  value={cptCode}
                  onChange={(e) => setCPTCode(e.target.value)}
                />
                {/* <DialogContentText> Description: </DialogContentText> */}
                {/* <TextField autoFocus margin="dense" id="cptDesc" fullWidth variant="standard" value={cptDescription}/> */}
                {/* <TextareaAutosize
                  minRows={4}
                  aria-label="maximum height"
                  style={{ width: 200 }}
                  value={cptDescription}
                /> */}
                <DialogContentText> Units: </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="units"
                  fullWidth
                  variant="standard"
                  value={cptunits}
                  onChange={(e) => setCPTUnits(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={UpdateCPT} data-id={props.rowID}>
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "delete") {
      return (
        <div>
          <DeleteOutlinedIcon
            sx={{ color: "#2F3744", cursor: "pointer" }}
            onClick={handleClickOpen}
          />
          {/* <Button
            buttonStyle={props.buttonStyle}
            buttonSize="btn--small"
            onClick={handleClickOpen}
          >
            <i className="fas fa-trash"></i>
          </Button> */}
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Remove CPT Code</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {" "}
                Please Confirm Removal of CPT {cptCode}{" "}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={removeCPTRow}>Confirm</Button>
              <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  } else if (props.ButtonID == "BtnDX") {
    if (props.proc == "add") {
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            {props.taskStatus != 3 &&
            props.taskStatus != 7 &&
            // props.taskStatus != 5 &&
            // props.taskStatus != 6 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 ? (
              <MuiButton
                variant="outlined"
                size="small"
                onClick={handleClickOpen}
                startIcon={<PlaylistAddIcon fontSize="inherit" />}
                style={{
                  borderColor: "#FB4E0B",
                  borderWidth: 1,
                  borderStyle: "solid",
                  color: "#000000",
                  backgroundColor: "#fff",
                  padding: 5,
                }}
              >
                {props.AddButtonText}
              </MuiButton>
            ) : (
              ""
            )}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-diagnosis-dialog"
            >
              <DialogTitle>Add Diagnosis Code</DialogTitle>
              <DialogContent>
                <DialogContentText>DX Code:</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="dx"
                  fullWidth
                  variant="standard"
                  value={dxCode}
                  onChange={(e) => setDXCode(e.target.value)}
                />
                {/* <DialogContentText> Description: </DialogContentText>
                <TextareaAutosize minRows={4} aria-label="maximum height" style={{ width: 200 }} value={dxDescription} /> */}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={AddDX}>Add</Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "update") {
      // console.log('value in update condition ', props.processData);
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            <BorderColorOutlinedIcon
              sx={{ color: "#2F3744", cursor: "pointer" }}
              onClick={handleClickOpen}
            />
            {/* <Button
              buttonStyle={props.buttonStyle}
              buttonSize="btn--small"
              onClick={handleClickOpen}
            >
              <i className="fas fa-pen"></i>
            </Button> */}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-diagnosis-dialog"
            >
              <DialogTitle>Update Diagnosis Code</DialogTitle>
              <DialogContent>
                <DialogContentText>DX Code:</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="dx"
                  fullWidth
                  variant="standard"
                  value={dxCode}
                  onChange={(e) => setDXCode(e.target.value)}
                />
                {/* <DialogContentText> Description: </DialogContentText>
                <TextareaAutosize
                  minRows={4}
                  aria-label="maximum height"
                  style={{ width: 200 }}
                  value={dxDescription}
                /> */}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={UpdateDX} data-id={props.rowID}>
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "delete") {
      return (
        <div>
          <DeleteOutlinedIcon
            sx={{ color: "#2F3744", cursor: "pointer" }}
            onClick={handleClickOpen}
          />
          {/* <Button
            buttonStyle={props.buttonStyle}
            buttonSize="btn--small"
            onClick={handleClickOpen}
          >
            <i className="fas fa-trash"></i>
          </Button> */}
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Remove Diagnosis Code</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {" "}
                Please Confirm Removal of Diagnosis Code {cptCode}{" "}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={removeDxRow}>Confirm</Button>
              <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  } else if (props.ButtonID == "BtnProvider") {
    if (props.proc == "add") {
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            {props.taskStatus != 3 &&
            props.taskStatus != 7 &&
            // props.taskStatus != 5 &&
            // props.taskStatus != 6 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 ? (
              <MuiButton
                variant="outlined"
                size="small"
                onClick={handleClickOpen}
                startIcon={<PlaylistAddIcon fontSize="inherit" />}
                style={{
                  borderColor: "#FB4E0B",
                  borderWidth: 1,
                  borderStyle: "solid",
                  color: "#000000",
                  backgroundColor: "#fff",
                  padding: 5,
                }}
              >
                {props.AddButtonText}
              </MuiButton>
            ) : (
              ""
            )}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-provider-dialog"
            >
              <DialogTitle>Add Provider</DialogTitle>
              <DialogContent>
                {/* <FormControl sx={{ mt: 2, minWidth: 120 }}> */}
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Provider Type:</DialogContentText>
                    <Select
                      variant="standard"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={providerType}
                      label="Provider Type"
                      onChange={(e) => setProviderType(e.target.value)}
                      className="provider-type-dropdown"
                    >
                      <MenuItem value={"Requesting Physician"}>
                        Requesting Physician
                      </MenuItem>
                      {/* <MenuItem value={"Servicing"}>Servicing</MenuItem> */}
                      <MenuItem value={"Facility Information"}>
                        Facility Information
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Provider Name:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerName}
                      onChange={(e) => setProviderName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText> NPI: </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerNPI}
                      onChange={(e) => setProviderNPI(e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xl={6} lg={6} md={6}>
                    <DialogContentText> Tax ID: </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerTax}
                      onChange={(e) => setProviderTax(e.target.value)}
                    />
                  </Grid> */}
                  <Grid item xl={12} lg={12} md={12}>
                    <DialogContentText> Address: </DialogContentText>
                    {/* <TextareaAutosize
                      minRows={4}
                      aria-label="maximum height"
                      style={{ width: 200 }}
                      value={providerAddress}
                      onChange={(e) => setProviderAddress(e.target.value)}
                    /> */}
                    <TextField
                      multiline
                      rows={2}
                      autoFocus
                      margin="dense"
                      fullWidth
                      variant="standard"
                      value={providerAddress}
                      onChange={(e) => setProviderAddress(e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>City:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerCity}
                      onChange={(e) => setProviderCity(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>State:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerState}
                      onChange={(e) => setProviderState(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Zip Code:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerZip}
                      onChange={(e) => setProviderZip(e.target.value)}
                    />
                  </Grid> */}
                  <Grid item xl={6} lg={6} md={6}>
                    <DialogContentText>Contact Phone:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerPhone}
                      onChange={(e) => setProviderPhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={6} lg={6} md={6}>
                    <DialogContentText>Contact Fax:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerFax}
                      onChange={(e) => setProviderFax(e.target.value)}
                    />
                  </Grid>
                </Grid>
                {/* </FormControl> */}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={AddProvider}>Add</Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "update") {
      if (isLoading) {
        return (
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
          />
        );
      } else {
        return (
          <div>
            <BorderColorOutlinedIcon
              sx={{ color: "#2F3744", cursor: "pointer" }}
              onClick={handleClickOpen}
            />
            {/* <Button
              buttonStyle={props.buttonStyle}
              buttonSize="btn--small"
              onClick={handleClickOpen}
            >
              <i className="fas fa-pen"></i>
            </Button> */}
            <Dialog
              open={open}
              onClose={handleClose}
              className="add-provider-dialog"
            >
              <DialogTitle>Update Provider</DialogTitle>
              <DialogContent>
                {/* <FormControl sx={{ mt: 2, minWidth: 120 }}> */}
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Provider Type:</DialogContentText>
                    <Select
                      className="provider-type-dropdown"
                      variant="standard"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={providerType}
                      label="Provider Type"
                      onChange={(e) => setProviderType(e.target.value)}
                    >
                      <MenuItem value={"Requesting Physician"}>
                        Requesting Physician
                      </MenuItem>
                      {/* <MenuItem value={"Servicing"}>Servicing</MenuItem> */}
                      <MenuItem value={"Facility Information"}>
                        Facility Information
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Provider Name:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerName}
                      onChange={(e) => setProviderName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText> NPI: </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerNPI}
                      onChange={(e) => setProviderNPI(e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText> Tax ID: </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerTax}
                      onChange={(e) => setProviderTax(e.target.value)}
                    />
                  </Grid> */}
                  <Grid item xl={12} lg={12} md={12}>
                    <DialogContentText> Address: </DialogContentText>
                    <TextField
                      multiline
                      rows={2}
                      autoFocus
                      margin="dense"
                      fullWidth
                      variant="standard"
                      value={providerAddress}
                      onChange={(e) => setProviderAddress(e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>City:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerCity}
                      onChange={(e) => setProviderCity(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>State:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerState}
                      onChange={(e) => setProviderState(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={4} lg={4} md={4}>
                    <DialogContentText>Zip Code:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerZip}
                      onChange={(e) => setProviderZip(e.target.value)}
                    />
                  </Grid> */}

                  <Grid item xl={6} lg={6} md={6}>
                    <DialogContentText>Contact Phone:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerPhone}
                      onChange={(e) => setProviderPhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item xl={6} lg={6} md={6}>
                    <DialogContentText>Contact Fax:</DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="dx"
                      fullWidth
                      variant="standard"
                      value={providerFax}
                      onChange={(e) => setProviderFax(e.target.value)}
                    />
                  </Grid>
                </Grid>
                {/* </FormControl> */}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={UpdateProvider} data-id={props.rowID}>
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    } else if (props.proc == "delete") {
      return (
        <div>
          <DeleteOutlinedIcon
            sx={{ color: "#2F3744", cursor: "pointer" }}
            onClick={handleClickOpen}
          />
          {/* <Button
            buttonStyle={props.buttonStyle}
            buttonSize="btn--small"
            onClick={handleClickOpen}
          >
            <i className="fas fa-trash"></i>
          </Button> */}
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Remove Provider Code</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {" "}
                Please Confirm Removal of Provider {providerName}{" "}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={removeProviderRow}>Confirm</Button>
              <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  } else {
    return <></>;
  }
}
